import React from "react"

export function HeroBlock({ programme }) {
  return (
    <div style={{ padding: "140px 60px 0", boxSizing: "border-box", maxWidth: 1000 }}>
      <p style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.08em", color: "#fff", margin: "0 0 16px" }}>
        Client Portal &nbsp;&middot;&nbsp; {programme.client}
      </p>
      <h1 style={{
        fontFamily: "Instrument Serif, Georgia, serif",
        fontSize: "clamp(48px, 7vw, 96px)",
        fontWeight: 400,
        lineHeight: 1.0,
        letterSpacing: "-0.025em",
        margin: "0 0 28px",
        color: "#fff",
      }}>
        {programme.name}
      </h1>
      {programme.subtitle && (
        <p style={{ fontSize: 16, lineHeight: 1.65, color: "#fff", maxWidth: 560, margin: 0 }}>
          {programme.subtitle}
        </p>
      )}
    </div>
  )
}
